import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/news`, {params})
    },
    create(params) {
        return Vue.axios.post(`/news/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/news/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/news/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/news/${id}`)
    },
}
